import { branding } from "../api/branding";
import { applyDocumentBranding } from "./documentBranding";

// Stores a culture-audit survey session from either login route (access code
// in CultureAuditLogin.tsx, pipeline link in PipelineJoin.tsx) and loads the
// client's branding, so the survey pages that follow behave the same.
export async function startSurveySession(data: any, accessCode: string | null): Promise<void> {
  // Store the full response (not just .user) — SurveyCard/Employee read
  // user?.user?.user_id, matching how the password-based login page
  // already stores it; CheckProfile.tsx stores only .user instead, which
  // is a pre-existing inconsistency we're not replicating here.
  sessionStorage.setItem("userToken", data?.token);
  sessionStorage.setItem("user", JSON.stringify(data));
  // Lets the survey sign the participant straight back in if their
  // session expires mid-survey (same credential as the link itself).
  if (accessCode) {
    sessionStorage.setItem("survey_access_code", accessCode);
  } else {
    sessionStorage.removeItem("survey_access_code");
  }
  sessionStorage.setItem("account_sub_type", data?.sub_type || "");
  sessionStorage.setItem("active-pipeline-id", data?.pipeline_id || "");
  // Contact Support only shows when the campaign has a support inbox.
  sessionStorage.setItem("survey_support_enabled", data?.support_enabled ? "1" : "");

  sessionStorage.removeItem("branding");
  if (data?.domain) {
    sessionStorage.setItem("domain", data.domain);
    // Dashboard.jsx is the only candidate page that fetches branding, and
    // culture audit never visits it (we go straight to self-review), so
    // fetch it here — SelfReview/SurveyCard/Loader read it from
    // sessionStorage.branding on mount. Branding failure shouldn't block
    // login; the pages just fall back to default colours.
    try {
      const brandingData = await branding.getBranding({ domain: data.domain });
      sessionStorage.setItem("branding", JSON.stringify(brandingData));
      applyDocumentBranding(brandingData);
    } catch (brandingError) {
      // ignore — default styling
    }
  }
}
